import { t } from 'i18next';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import useLogin from '~hooks/useLogin/useLogin';
import { ResetSignupProps } from '~pages/Auth/types';

import SignUpResetForm from './SignUpResetForm';

const tokenUrl = 'token';
const ResetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { resetPassword } = useLogin();
  const [searchParams] = useSearchParams();
  const token = searchParams.get(tokenUrl)!;

  const handleSubmitReset = async (data: ResetSignupProps) => {
    setIsLoading(true);
    try {
      await resetPassword({
        password_reset_token: token,
        password: data.password,
      });
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SignUpResetForm
      formTitle={t('page_headings.reset_password')}
      callBackAction={handleSubmitReset}
      isLoading={isLoading}
      isReset={true}
    />
  );
};
export default ResetPassword;
